<template>
  <form
    v-if="loaded"
    class=""
    action=""
    method="post"
    v-on:submit.prevent="handleSubmit()"
  >
    <div class="form__content">
      <div class="field-group">
        <hr>
      </div>
      <div class="field-group">
        <TextInput
          index="firstName"
          v-bind:field="data.firstName"
          v-bind:initial="firstName"
          v-model="firstName"
          validate="required"
          autocomplete="given-name"
        />
      </div>
      <div class="field-group">
        <TextInput
          index="lastName"
          v-bind:field="data.lastName"
          v-bind:initial="lastName"
          v-model="lastName"
          validate="required"
          autocomplete="family-name"
        />
      </div>
      <div class="field-group">
        <TextInput
          index="email"
          v-bind:field="data.email"
          v-bind:initial="email"
          v-model="email"
          validate="required|email"
          autocomplete="email"
        />
      </div>
      <div class="field-group">
        <MobileField
          index="mobile"
          v-bind:field="data.mobile"
          v-bind:initial="mobile"
          v-model="mobile"
          autocomplete="tel"
          name="mobile"
          v-bind:class="{
            'error--hide': hideMobileError,
          }"
          v-validate="{
            required: data.mobile.mandatory,
            regex: /^\+(6[1-4])[0-9]{7,}$/,
          }"
        />
      </div>
      <div class="field-group">
        <LabelField
          v-bind:field="data.dob"
        />
        <DateInput
          index="dob"
          v-bind:field="data.dob"
          v-model="dob"
          v-bind:initial="dob"
          name="dob"
          v-validate="{
            required: data.dob.mandatory,
            date_format: 'dd/MM/yyyy',
          }"
          v-bind:class="{
            'error--hide': hideDobError,
          }"
        />
      </div>
      <div class="field-group">
        <LabelField
          v-bind:field="data.gender"
          classname="label--group"
        />
        <div class="field-set">
          <div
            v-if="data.gender.title"
            class="field__title"
          >
            {{data.gender.title}}
          </div>
          <div
            v-if="data.gender.text"
            class="field__description"
          >
            {{data.gender.text}}
          </div>
          <RadioCheckboxGroup
            v-bind:fieldArray="data.gender.fields"
            v-bind:type="data.gender.type"
            v-bind:inline="data.gender.inline"
            v-bind:initial="gender"
            v-model="gender"
            validate="required"
            errorMsg="Please select a preference."
          />
        </div>
      </div>
      <div class="field-group">
        <hr>
      </div>
      <div class="field-group">
        <div class="field-set">
          <RadioCheckboxGroup
            v-bind:fieldArray="data.TandC.fields"
            v-bind:type="data.TandC.type"
            v-bind:inline="data.TandC.inline"
            v-bind:initial="tandc"
            v-model="tandc"
            validate="required"
            errorMsg="Please confirm Terms and Conditions."
          />
          <RadioCheckboxGroup
            v-bind:fieldArray="data.privacy.fields"
            v-bind:type="data.privacy.type"
            v-bind:inline="data.privacy.inline"
            v-bind:initial="privacyPolicy"
            v-model="privacyPolicy"
            validate="required"
            errorMsg="Please agree to the Privacy Policy."
          />
        </div>
      </div>
      <div class="field-group">
        <p class="field__text">* Required Fields</p>
      </div>
      <div
        class="field-group field-group--center"
        v-bind:class="{
          'is-danger--hide': hideSubmitError,
        }"
      >
        <div class="is-danger">
          <span v-html="submitErrorMsg"></span>
        </div>
      </div>
      <div class="field-group field-group--center">
        <ButtonField
          index="submit"
          v-bind:field="data.button"
        />
      </div>
    </div>
  </form>
  <Loading v-else/>
</template>

<script>
// @ is an alias to /src
import form from '@/components/mixin/form';
import Loading from '@/components/Loading.vue';

// Data
import fieldData from '@/data/form-confirm-fields.json';

export default {
  name: 'ConfirmForm',
  mixins: [form],
  components: {
    Loading,
  },
  data() {
    return {
      data: fieldData.formFields,
      loaded: false,
      crmId: '',
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
      dob: '',
      gender: '',
      accountNumber: '',
      nameSequence: '',
      locale: '',
      tandc: '',
      privacyPolicy: '',
      submitErrorMsg: 'Please fill in all mandatory fields.',
    };
  },
  mounted() {
    this.getInitialData();
  },
  methods: {
    getInitialData() {
      this.crmId = this.$route.params.crmId;
      const getUrl = `https://ui9x5yrom4.execute-api.ap-southeast-2.amazonaws.com/prod/customer/${this.crmId}`;

      this.tandc = '';
      this.privacyPolicy = '';

      this.axios({
        method: 'get',
        url: getUrl,
      }).then((response) => {
        /* eslint-disable */
        // console.log(response);
        const data = response.data;
        // console.log(data);
        /* eslint-enable */

        // TODO: Populate Vue data with response from Salesforce API
        this.firstName = data.customer.FirstName;
        this.lastName = data.customer.LastName;
        this.email = data.customer.Email;
        this.mobile = data.customer.Mobile ? `+${data.customer.Mobile}` : data.customer.Mobile;
        this.dob = data.customer.DOB;
        this.gender = ['F', 'M'].includes(data.crm['2.004']) ? data.crm['2.004'] : '';
        this.accountNumber = data.customer.MailerItemNumber;
        this.nameSequence = data.customer.MailerNameSeq;
        this.locale = data.customer.Locale;

        // Mount form component to set initial data properly
        this.loaded = true;
      }).catch((error) => {
        console.error('Error: ', error);
        // Fallback to URL params if Salesforce API fails
        this.firstName = this.$route.params.name;
        this.email = this.$route.params.email;

        // Mount form component to set initial data properly
        this.loaded = true;
      });
    },
    handleSubmit() {
      this.validateForm(() => {
        const postUrl = 'https://ui9x5yrom4.execute-api.ap-southeast-2.amazonaws.com/prod/update';

        const headers = {
          'Content-Type': 'application/json',
        };

        // Please make sure `contact` and `account` are present as top level keys under `postData`
        // If empty, you must pass through an empty object, i.e. {}

        const postData = {
          locale: this.locale,
          crmId: this.crmId,
          contact: {
            CrmUpdateContactsRequest: {
              Contacts: [
                {
                  name: 'Contact',
                  attrs: `NameSequence="${this.nameSequence}"`,
                  children: [
                    {
                      name: 'FirstName',
                      text: this.firstName,
                    },
                    {
                      name: 'Surname',
                      text: this.lastName,
                    },
                    {
                      name: 'Email',
                      text: this.email,
                    },
                    {
                      name: 'MobileNumber',
                      text: this.validateMobileNumber(this.mobile),
                    },
                    {
                      name: 'MnUserOnlyDate1',
                      text: this.dob.replace(/\//g, ' '),
                    },
                  ],
                },
              ],
            },
          },
          account: {
            CrmUpdateAccountsRequest: {
              Accounts: [
                {
                  name: 'Account',
                  attrs: `AccountNumber="${this.accountNumber}"`,
                  children: [
                    {
                      name: 'Attributes',
                      children: [
                        {
                          name: 'Attribute',
                          children: [
                            {
                              name: 'AttributeNo',
                              text: '2.004', // gender
                            },
                            {
                              name: 'AttributeValueCode',
                              text: this.gender,
                            },
                          ],
                        },
                        {
                          name: 'Attribute',
                          children: [
                            {
                              name: 'AttributeNo',
                              text: '2.003', // t and c
                            },
                            {
                              name: 'AttributeValueCode',
                              text: this.tandc[0] === 'agree' ? 'Y' : 'N',
                            },
                          ],
                        },
                        {
                          name: 'Attribute',
                          children: [
                            {
                              name: 'AttributeNo',
                              text: '2.005', // privacy policy
                            },
                            {
                              name: 'AttributeValueCode',
                              text: this.privacyPolicy[0] === 'agree' ? 'Y' : 'N',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        };

        // const postData = {
        //   crmId: this.crmId,
        //   firstName: this.firstName,
        //   lastName: this.lastName,
        //   email: this.email,
        //   mobile: this.mobile,
        //   dob: this.dob,
        //   gender: this.gender,
        // };

        this.$store.commit('setSubmitting', true);

        this.axios({
          method: 'post',
          url: postUrl,
          data: postData,
          headers,
        }).then((response) => {
          this.$store.commit('setSubmitting', false);
          this.$router.push({ path: `/thank-you/${this.$route.params.store}` });
          console.log(response.data);
          // console.log(`Success: ${response.data}`);
        }).catch((error) => {
          this.hideSubmitError = false;
          this.submitErrorMsg = `Sorry ${this.firstName}, we're having trouble saving your details at this time.<br>Please check back soon.`;
          this.$store.commit('setSubmitting', false);
          console.error(`Error: ${error}`);
          // TODO: Show error state/message
        });
      });
    },
  },
};
</script>
